import { render } from "./CustomSelect.vue?vue&type=template&id=1cd756d0&scoped=true"
import script from "./CustomSelect.vue?vue&type=script&lang=js"
export * from "./CustomSelect.vue?vue&type=script&lang=js"

import "./CustomSelect.vue?vue&type=style&index=0&id=1cd756d0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1cd756d0"

export default script